import {
    CSSProperties,
    ChangeEvent,
    ChangeEventHandler,
    Dispatch,
    JSXElementConstructor,
    MouseEventHandler,
    ReactElement,
    ReactNode,
    ReactPortal,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from 'react'
import { useForm } from 'react-hook-form'
import DatePicker from '../../Components/DatePicker/DatePicker'
import moment from 'moment'
import 'moment-timezone'
import { FoundationsRequest, getBaseUrl, updateHookArray } from '../../Utils'
import { memo } from 'react'
import {
    PriorityCodes,
    RequestStatus,
    RequestType,
    RequestedStatusName,
    Status,
    tzMap,
} from '../../Redux/WLM/wlmEnums'
import { useSelector, useDispatch } from 'react-redux'
import { selectField } from '../../Redux/WLM/wlmSelectors'
import store from '../../Redux/store'
import Dialog from '../../GenericComponents/dialog'
import { useTimeout } from 'usehooks-ts'

declare let window: any
const UnicornApp = window.unicornInstance as any

const DateTimeCompo = memo(
    (props: {
        label:
            | string
            | number
            | boolean
            | ReactElement<any, string | JSXElementConstructor<any>>
            | Iterable<ReactNode>
            | ReactPortal
            | null
            | undefined
        style?: CSSProperties | undefined
        dateValue: string
        setDateValue: (value: SetStateAction<string>) => void
        setTime: (arg0: string) => void
        time: string
    }) => {
        // TODO fiux date format issue and parsing date from moment
        const dateFormat =
            props.dateValue && props.dateValue.indexOf('-') > 0 ? 'yyyy-MM-DD' : 'MM/DD/YYYY'
        return (
            <>
                <table>
                    <tr>
                        <td>
                            <label className="wlm-sm">{props.label}</label>
                        </td>
                        <td>
                            <label className="wlm-sm">Time (24H)</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <DatePicker
                                dateFormat={dateFormat}
                                style={props.style}
                                showIcon={false}
                                startingDate={moment(props.dateValue, dateFormat)?.toDate()}
                                setStartingDate={props.setDateValue}
                            />
                        </td>
                        <td>
                            <input
                                style={{ width: '3ch' }}
                                maxLength={2}
                                onChange={(element) => {
                                    const timePieces = props.time.split(':')
                                    const newValue = element.currentTarget.value
                                    const newTime =
                                        newValue + ':' + timePieces[1] + ':' + timePieces[2]
                                    props.setTime(newTime)
                                }}
                                value={props.time.split(':')[0]}
                            />
                            :
                            <input
                                style={{ width: '3ch' }}
                                maxLength={2}
                                onChange={(element) => {
                                    const timePieces = props.time.split(':')
                                    const newValue = element.currentTarget.value
                                    const newTime =
                                        timePieces[0] + ':' + newValue + ':' + timePieces[2]
                                    props.setTime(newTime)
                                }}
                                value={props.time.split(':')[1]}
                            />
                        </td>
                    </tr>
                </table>
            </>
        )
    }
)

const WeekCompo = memo(
    (props: {
        dayOfWeeks: boolean[]
        updateDayOfWeek: (index: number, checked: boolean) => void
    }) => {
        return (
            <table style={{ padding: '20px' }}>
                <tr>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[0]}
                            onChange={() => props.updateDayOfWeek(0, !props.dayOfWeeks[0])}
                        />
                        <label>Mon</label>
                    </td>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[1]}
                            onChange={() => props.updateDayOfWeek(1, !props.dayOfWeeks[1])}
                        />
                        <label>Tue</label>
                    </td>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[2]}
                            onChange={() => props.updateDayOfWeek(2, !props.dayOfWeeks[2])}
                        />
                        <label>Wed</label>
                    </td>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[3]}
                            onChange={() => props.updateDayOfWeek(3, !props.dayOfWeeks[3])}
                        />
                        <label>Thu</label>
                    </td>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[4]}
                            onChange={() => props.updateDayOfWeek(4, !props.dayOfWeeks[4])}
                        />
                        <label>Fri</label>
                    </td>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[5]}
                            onChange={() => props.updateDayOfWeek(5, !props.dayOfWeeks[5])}
                        />
                        <label>Sat</label>
                    </td>
                    <td>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[6]}
                            onChange={() => props.updateDayOfWeek(6, !props.dayOfWeeks[6])}
                        />
                        <label>Sun</label>
                    </td>
                </tr>
                <tr>
                    <td colSpan={7} style={{ padding: '3px' }}>
                        <input
                            type="checkbox"
                            checked={props.dayOfWeeks[7]}
                            onChange={() => props.updateDayOfWeek(7, !props.dayOfWeeks[7])}
                        />
                        <label>All Days</label>
                    </td>
                </tr>
            </table>
        )
    }
)

// TODO ->
// if (ctrl.showModal) {
//     m.mount(document.getElementById("wlm-modal"), new ModalCompo(ctrl));
// }

const SiteCompo = memo(
    (props: {
        allowSitePick: any
        selectedSite: string | number | readonly string[] | undefined
        permittedSites: {
            Id: number
            SiteName: string
            TzCode: string
        }[]
        setSelectedSiteId: (siteId: number) => void
        selectedItem: {
            id?: Number | undefined
            actualRequesterId?: number | undefined
            requestStatus?: number | undefined
            effectiveRequesterId?: number | undefined
            priority?: PriorityCodes | undefined
            requestType?: RequestType | undefined
            siteId?: number | undefined
            siteName: string
            ts_creationDateTime?: Date | undefined
            ts_modificationDateTime?: Date | undefined
        }
    }) => {
        const dispatch = useDispatch()

        return (
            <>
                {props.allowSitePick ? (
                    <select
                        value={props.selectedSite}
                        onChange={(e: {
                            target: {
                                value: string
                            }
                        }) => {
                            if (props.permittedSites && props.permittedSites.length > 0) {
                                var site = props.permittedSites.find((i: { Id: number }) => {
                                    return i.Id === Number(e.target?.value)
                                })

                                props.setSelectedSiteId(Number(e.target?.value))

                                dispatch({
                                    type: 'wlm/set-selectedSite',
                                    payload: Number(e.target?.value),
                                })

                                dispatch({
                                    type: 'wlm/set-selectedSiteName',
                                    payload: site?.SiteName,
                                })
                                dispatch({ type: 'wlm/set-selectedSiteTz', payload: site?.TzCode })
                            }
                        }}
                                style={{width: '200px' }}// Ensure consistent width
                            >
                        {props.permittedSites
                            .filter(
                                (i: { TzCode: string | undefined }) =>
                                    i.TzCode != undefined && i.TzCode != ''
                            )
                            .map((site) => {
                                return <option value={'' + site.Id}>{site.SiteName}</option>
                            })}
                    </select>
                ) : (
                    <span> {props.selectedItem.siteName} </span>
                )}
            </>
        )
    }
)

const RequestTypeCompo = memo(
    (props: {
        onRequestTypeChangd: (index: number) => void
        selectedItem: { requestType?: number }
        setRequestType: (index: number, value: boolean) => void
        configs: { requestTypes: { [x: string]: string }; priorities: { [x: string]: string } }
        requestType: boolean[]
    }) => {
        return (
            <table style={{ width: '100%' }}>
                <tr>
                    {Object.keys(props.configs.requestTypes).map((key) => {
                        return <td style={{ width: '20%' }}>{props.configs.requestTypes[key]}</td>
                    })}
                </tr>
                <tr>
                    {Object.keys(props.configs.requestTypes).map((key, index) => {
                        return (
                            <td style={{ width: '20%' }}>
                                <input
                                    id={'requests-' + props.configs.requestTypes[key]}
                                    type="radio"
                                    name="requests"
                                    disabled={props.configs.requestTypes[key] === 'MOU'}
                                    checked={props.requestType[index]}
                                    onClick={() => props.onRequestTypeChangd(Number(key))}
                                ></input>
                            </td>
                        )
                    })}
                </tr>
            </table>
        )
    }
)

const ModalityTableCompo = memo(
    (props: {
        modalities: { [s: string]: string }
        modalityCounts: number[]
        modalitySum: number
        updateModalityCounts: (index: number, value: number) => void
        setModalitySum: (sum: number) => void
    }) => {
        const modalityKeys = Object.keys(props.modalities)
        const [localCounts, setLocalCounts] = useState<string[]>([])
    // Keep localCounts in sync with props when props.modalityCounts changes
    useEffect(() => {
      setLocalCounts(props.modalityCounts.map(String)) // convert to strings for input
    }, [props.modalityCounts])
    // Initialize invalid counts to 0 on mount
    useEffect(() => {
      modalityKeys.forEach((key) => {
        const idx = Number(key)
        if (
          props.modalityCounts[idx] < 0 ||
          props.modalityCounts[idx] === undefined
        ) {
          props.updateModalityCounts(idx, 0)
        }
      })
    }, [])
    // Handle user typing
    const handleChange = (key: string, e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value
      const index = Number(key)
      const updated = [...localCounts]
      updated[index] = value // store raw input as string
      setLocalCounts(updated)
    }
    // Handle user leaving input field
    const handleBlur = (key: string, e: React.FocusEvent<HTMLInputElement>) => {
      const value = e.target.value.trim()
      const numericValue = Number(value)
      const index = Number(key)
      if (value === '' || isNaN(numericValue)) {
        // Invalid input: set NaN sum and reset field to "0"
        props.setModalitySum(NaN)
        const updated = [...localCounts]
        updated[index] = '0'
        setLocalCounts(updated)
        return
      }
      // Valid input: update Redux and local state
      props.updateModalityCounts(index, numericValue)
      const updatedCounts = [...props.modalityCounts]
      updatedCounts[index] = numericValue
      const newSum = updatedCounts.reduce((acc, val) => acc + (typeof val === 'number' ? val : 0), 0)
      props.setModalitySum(newSum)
      const updated = [...localCounts]
      updated[index] = numericValue.toString()
      setLocalCounts(updated)
    }
    return (
      <table style={{ padding: '20px' }}>
          <tr>
            <td colSpan={4}>Modality Cases For The Day : Total {props.modalitySum}</td>
          </tr>
          <tr>
            {modalityKeys.map((key, index) =>
              index > 0 ? (
                <td key={key} style={{ fontSize: 'small' }}>
                  {props.modalities[key]}
                </td>
              ) : null
            )}
          </tr>
          <tr>
            {modalityKeys.map((key, index) =>
              index > 0 ? (
                <td key={key}>
                  <input
                    style={{ width: '30px' }}
                    type="text"
                    value={localCounts[Number(key)] ?? ''}
                    onChange={(e) => handleChange(key, e)}
                    onBlur={(e) => handleBlur(key, e)}
                  />
                </td>
              ) : null
            )}
          </tr>
      </table>
    );
});

const PriorityCompo = memo(
    (props: {
        selectedItem: { priority?: number }
        configs: { priorities: { [x: string]: string } }
        priority: boolean[]
        setSelectedItemPriority: (priority: number | undefined) => void
    }) => {
        const dispatch = useDispatch()
        return (
            <table style={{ width: '100%' }}>
                <tr>
                    {Object.keys(props.configs.priorities).map((key) => {
                        return <td style={{ width: '20%' }}>{props.configs.priorities[key]}</td>
                    })}
                </tr>
                <tr>
                    {Object.keys(props.configs.priorities).map((key, index) => {
                        return (
                            <td style={{ width: '20%' }}>
                                <input
                                    id={'prio-' + props.configs.priorities[key]}
                                    type="radio"
                                    name="prio"
                                    checked={props.priority[index]}
                                    onClick={() => {
                                        const tempPriorities = Object.keys(
                                            props.configs.priorities
                                        ).map((_) => false)
                                        tempPriorities[index] = true
                                        dispatch({
                                            type: 'wlm/set-priorities',
                                            payload: tempPriorities,
                                        })
                                        props.setSelectedItemPriority(Number(key))
                                    }}
                                ></input>
                            </td>
                        )
                    })}
                </tr>
            </table>
        )
    }
)

const CommentListCompo = memo((props: { currentUser: number }) => {
    const comments: { postedById: number; LastName: string; Age: string; Comment: string }[] =
        useSelector(selectField('comments')) || []

    return (
        <div>
            Previous Notes:
            <div style={{ height: '105px', overflowY: 'auto' }}>
                <table style={{ borderSpacing: '30px', width: '100%' }}>
                    {comments.map(
                        (
                            comment: {
                                postedById: number
                                LastName: string
                                Age: string
                                Comment: string
                            },
                            index: number
                        ) => {
                            var bg = index % 2 ? '#e5f5ff' : '#f3f3f3'
                            var margin = comment.postedById === props.currentUser ? '0px' : '20px'
                            return (
                                <div>
                                    <div
                                        className="workloadNote"
                                        style={{
                                            background: bg,
                                            padding: '4px',
                                            marginBottom: '5px',
                                            color: '#60686d',
                                            marginLeft: margin,
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: 'x-small',
                                                color: '#656c71',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {comment.LastName + ' wrote ' + comment.Age}
                                            <br />
                                            <span>{comment.Comment}</span>
                                        </span>
                                    </div>
                                </div>
                            )
                        }
                    )}
                </table>
            </div>
        </div>
    )
})

function WlmForm() {
    const dispatch = useDispatch()
    const [currentUser, setCurrentUser] = useState(0)
    const modalityCounts: number[] = useSelector(selectField('modalityCounts')) || []
    const selectedItem = useSelector(selectField('selectedItem'))
    const startingDate = useSelector(selectField('startingDate'))
    const endingDate = useSelector(selectField('endingDate'))
    const startingTime = useSelector(selectField('startingTime'))
    const endingTime = useSelector(selectField('endingTime'))
    const permittedSites = useSelector(selectField('permittedSites'))
    const selectedSite: string | number = useSelector(selectField('selectedSite'))
    const selectedSiteName: string = useSelector(selectField('selectedSiteName')) || 'Select Site'
    const selectedSiteTz: string = useSelector(selectField('selectedSiteTz')) || 'No Site'
    const statusMessage: string = useSelector(selectField('statusMessage'))
    const messageAsync = useSelector(selectField('messageAsync'))
    const statusType: number = useSelector(selectField('statusType'))
    // const requestId = useSelector(selectField('requestId'));
    const priorities: boolean[] = useSelector(selectField('priorities')) || []

    const requestType: boolean[] = useSelector(selectField('requestType')) || []
    // const pickedRowId = useSelector(selectField('pickedRowId'));
    // const pickedElement = useSelector(selectField('pickedElement'));
    const dayOfWeeks: boolean[] = useSelector(selectField('dayOfWeeks')) || []
    const permissions: {
        CanSubmit: boolean
        CanDecline: boolean
        CanAccept: boolean
        CanCancel: boolean
    } = useSelector(selectField('permissions'))
    const configs: any = useSelector(selectField('configs')) || {}
    const allowSitePick: boolean = useSelector(selectField('allowSitePick'))
    const listReload: boolean = useSelector(selectField('listReload'))
    const [newComment, setNewComment] = useState('')
    const [modalitySum, setModalitySum] = useState(0)
    const [modalContents, setModalContents] = useState({})
    const [deleteOpen, setDeleteOpen] = useState(false)
    const updateDispatchArray = (value: any, index: number, oldArray: any[], name: string) => {
        const newArray = [...oldArray]
        newArray[index] = value
        dispatch({ type: 'wlm/set-' + name, payload: newArray })
    }
    const [isMessageVisible, setIsMessageVisible] = useState(false);
    const hideMessage = () => {
        setIsMessageVisible(false);
    };
    useTimeout(hideMessage, isMessageVisible ? 3000 : null);
    /** TODO migrate functions
     *
     * this.onDateTimeChanged
     * this.onDayOfWeekChanged
     */

    // TODO test that timezone conversion works correctly!
    const toDateFromFields = (datePart: string, timePart: string, tzCode: string) => {
        var mo =
            datePart.indexOf('/') > 0
                ? moment.tz(datePart + ' ' + timePart, 'MM/DD/YYYY HH:mm:ss', tzMap[tzCode])
                : moment.tz(datePart + ' ' + timePart, tzMap[tzCode])
        var datetime = new Date(mo.valueOf())
        return datetime
    }

    const saveForm = (requestStatus: Number) => {
        const requestSummary = (
            ' ' +
            modalitySum +
            ' case' +
            (modalitySum > 1 ? 's' : '') +
            ' for ' +
            (dayOfWeeks[0] ? 'Mo,' : '') +
            (dayOfWeeks[1] ? 'Tu,' : '') +
            (dayOfWeeks[2] ? 'We,' : '') +
            (dayOfWeeks[3] ? 'Th,' : '') +
            (dayOfWeeks[4] ? 'Fr,' : '') +
            (dayOfWeeks[5] ? 'Sa,' : '') +
            (dayOfWeeks[6] ? 'Su,' : '') +
            ', '
        )
            .replace(',,', ',')
            .replace(', ', ' ')

        const postData = {
            id: selectedItem.id,
            actualRequesterId:
                selectedItem.actualRequesterId > 0 ? selectedItem.actualRequesterId : currentUser,
            siteId: selectedItem.siteId ? selectedItem.siteId : selectedSite,
            priority: selectedItem.priority ? selectedItem.priority : PriorityCodes.routine,
            requestType: selectedItem.requestType ? selectedItem.requestType : RequestType.mou,
            examType: 0, // not used
            requestStatus: requestStatus,
            startingDateTime: toDateFromFields(startingDate, startingTime, selectedSiteTz),
            endingDateTime: toDateFromFields(endingDate, endingTime, selectedSiteTz),
            startingDate: moment(startingDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            startingTime: startingTime,
            endingDate: moment(endingDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            endingTime: endingTime,
            TZCode: selectedSiteTz,
            isDeleted: false,
            approverUserId:
                requestStatus == RequestStatus.accepted || requestStatus == RequestStatus.declined
                    ? currentUser
                    : selectedItem.approverUserId,
            comment: newComment,
            effectiveRequesterId:
                selectedItem.effectiveRequesterId > 0
                    ? selectedItem.effectiveRequesterId
                    : currentUser,
            callbackNumber: selectedItem.callbackNumber,
            reqMon: dayOfWeeks[0],
            reqTue: dayOfWeeks[1],
            reqWed: dayOfWeeks[2],
            reqThu: dayOfWeeks[3],
            reqFri: dayOfWeeks[4],
            reqSat: dayOfWeeks[5],
            reqSun: dayOfWeeks[6],
            PF_Count: 0,
            CT_Count: 0,
            MR_Count: 0,
            US_Count: 0,
            OT_Count: 0,
            MG_Count: 0,
            requestSummary: requestSummary,
        }
        let message = ''
        let invalid = !(
            postData.reqMon ||
            postData.reqTue ||
            postData.reqWed ||
            postData.reqThu ||
            postData.reqFri ||
            postData.reqSat ||
            postData.reqSun
        )

        if (invalid) {
            message = 'Please check at least one of the Requested Days.'
        }
        if (modalitySum === 0) {
            invalid = true
            message = message + ' Please add least one modality case. All are zero now.'
        }
        if(isNaN(modalitySum)){
            invalid=true
            message=message +'Contact support. Problem saving request. null'
        }
        if (selectedItem.siteId < 1) {
            invalid = true
            message = message + ' Please select Site before submitting form.'
        }
        if (selectedItem.id != undefined && requestStatus != RequestStatus.accepted) {
            if (postData.comment.trim() == '') {
                // FP-9088 - justification comment should not accept blank spaces.
                invalid = true
                message = message + ' Please add Note before submitting modified request.'
            }
        }
        if (invalid) {
            // setMessageAsynch(statusAsynch(message));
            dispatch({ type: 'wlm/set-statusMessage', payload: message })
            dispatch({ type: 'wlm/set-statusType', payload: Status.ERROR })
            return false
        }

        Object.values(configs.modalities as { [x: string]: String }).forEach(function (
            modality: String,
            index: number
        ) {
            var mc = modalityCounts[index]
            var count = Number(mc)
            switch (modality.valueOf()) {
                case 'PF':
                case 'DX':
                    postData.PF_Count = count
                    break
                case 'CT':
                    postData.CT_Count = count
                    break
                case 'MR':
                    postData.MR_Count = count
                    break
                case 'US':
                    postData.US_Count = count
                    break
                case 'OT':
                    postData.OT_Count = count
                    break
                case 'MG':
                    postData.MG_Count = count
                    break
            }
        })
        const printDow = function () {
            var msg =
                'Saving: Mon:' +
                postData.reqMon +
                ', Tue:' +
                postData.reqTue +
                ', Wed:' +
                postData.reqWed +
                ', Thu:' +
                postData.reqThu +
                ', Fri:' +
                postData.reqFri +
                ', Sat:' +
                postData.reqSat +
                ', Sun:' +
                postData.reqSun
        }
        printDow()
        FoundationsRequest('POST', {
            url: getBaseUrl() + 'API/v3/wlm/save',
            data: postData,
            cache: false,
            includeTokenHeader: true,
            success: function (response: { data: any }) {
                var resp = response.data
                dispatch({
                    type: 'wlm/set-statusMessage',
                    payload: 'Request ' + resp.id + ' saved',
                })
                // TODO messageasync
                // setMessageAsynch(statusAsynch("Request " + response.id + " saved"));
                dispatch({ type: 'wlm/set-statusType', payload: Status.SUCCESS })

                clearForm(true)
                reloadLists()
            },
            error: function (error: string) {
                dispatch({
                    type: 'wlm/set-statusMessage',
                    payload: 'Contact support. Problem saving request. ' + error,
                })
                // TODO messageasync
                // setMessageAsynch(statusAsynch("Contact support. Problem saving request. " + error))
                dispatch({ type: 'wlm/set-statusType', payload: Status.ERROR })
            },
        })
    }

    const reloadLists = () => {
        dispatch({ type: 'wlm/set-listReload', payload: !listReload })
    }

    const onNewForm = () => {
        clearForm(true)
        dispatch({
            type: 'wlm/set-statusMessage',
            payload: 'You may now enter a new request into the form.',
        })

        // c.messageAsynch = c.statusAsynch(c.statusMessage());
        dispatch({ type: 'wlm/set-statusType', payload: Status.SUCCESS })
        reloadLists()
        setIsMessageVisible(true);
    }
    const onSubmit = () => {
        // Clear previous messages
        dispatch({ type: 'wlm/set-statusMessage', payload: '' });
        saveForm(RequestStatus.open);
        setIsMessageVisible(true);
    }
    const onAccept = () => {
        var tempSelectedItem = { ...selectedItem }
        tempSelectedItem.requestStatus = RequestStatus.accepted
        dispatch({ type: 'wlm/set-selectedItem', payload: tempSelectedItem })
        saveForm(RequestStatus.accepted)
        setIsMessageVisible(true);
    }
    const onDecline = () => {
        var tempSelectedItem = { ...selectedItem }
        tempSelectedItem.requestStatus = RequestStatus.declined
        dispatch({ type: 'wlm/set-selectedItem', payload: tempSelectedItem })
        saveForm(RequestStatus.declined)
        setIsMessageVisible(true);
    }
    const onDeleteRequest = () => {
        // if (tag.toLowerCase() === 'delete') {
        var requestId_1 = selectedItem.id
        if (requestId_1 !== undefined) {
            FoundationsRequest('DELETE', {
                url: getBaseUrl() + 'API/v3/wlm/request/' + requestId_1,
                cache: false,
                includeTokenHeader: true,
                success: function (response: { data: any; id: string }) {
                    dispatch({
                        type: 'wlm/set-statusMessage',
                        payload: 'Request ' + requestId_1 + ' deleted.',
                    })
                    // TODO
                    // setMessageAsynch(statusAsynch(statusMessage());
                    dispatch({ type: 'wlm/set-statusType', payload: Status.SUCCESS })
                    setIsMessageVisible(true)
                    reloadLists()
                    clearForm(true)
                },
                error: function (error: string) {
                    dispatch({
                        type: 'wlm/set-statusMessage',
                        payload:
                            'Technical problem. Please contact support: ' +
                            requestId_1 +
                            ': ' +
                            error,
                    })
                    dispatch({ type: 'wlm/set-statusType', payload: Status.ERROR })
                },
            })
        }
        clearForm(true)
        setDeleteOpen(false)
    }

    const cancelDelete = () => {
        dispatch({
            type: 'wlm/set-statusMessage',
            payload: 'Deletion was cancelled. You may continue to edit the form',
        })
        dispatch({ type: 'wlm/set-statusType', payload: Status.SUCCESS })
        setDeleteOpen(false)
    }

    const loadConfigs = () => {
        // TODO replace API calls with redux call and use redux to avoid rerendering after every API change
        dispatch({ type: 'wlm/clearForm' })
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/wlm/config',
            cache: false,
            includeTokenHeader: true,
            success: function (response: { data: { Config: any } }) {
                dispatch({ type: 'wlm/set-configs', payload: response.data.Config })
                dispatch({
                    type: 'wlm/set-priorities',
                    payload: Object.values(response.data.Config.priorities).map((_, index) => {
                        if (index === 1) return true
                        return false
                    }),
                })
                dispatch({
                    type: 'wlm/set-requestType',
                    payload: Object.values(response.data.Config.requestTypes).map((_, index) => {
                        if (index === 1) return true
                        return false
                    }),
                })
                dispatch({
                    type: 'wlm/set-modalities',
                    payload: Object.values(response.data.Config.modalities) || [],
                })
                dispatch({
                    type: 'wlm/set-modalityCounts',
                    payload: Object.keys(response.data.Config.modalities)?.map((_) => 0) || [],
                })
                clearForm(false)
            },
        })
    }

    const loadUser = () => {
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/wlm/account-id',
            cache: false,
            includeTokenHeader: true,
            // contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            success: function (response: { data: { Id: SetStateAction<number> } }) {
                setCurrentUser(response.data.Id)
            },
        })
    }

    const loadPermittedSites = () => {
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/wlm/sites',
            cache: false,
            includeTokenHeader: true,
            success: function (response: {
                data: SetStateAction<{ Id: number; SiteName: string; TzCode: string }[]>
                statusCode: string
            }) {
                dispatch({ type: 'wlm/set-permittedSites', payload: response.data || [] })

                if (response.statusCode == '401') {
                    dispatch({ type: 'wlm/set-permittedSites', payload: [] })

                    dispatch({ type: 'wlm/set-selectedSite', payload: -1 })
                    dispatch({ type: 'wlm/set-selectedSiteName', payload: '' })
                    dispatch({ type: 'wlm/set-selectedSiteTz', payload: '' })
                    dispatch({
                        type: 'wlm/set-statusMessage',
                        payload:
                            'You are not authorized to access Workload Manager. Please contact admin to request access.',
                    })
                    // TODO messageAsynch
                    // c.messageAsynch = c.statusAsynch(c.statusMessage());
                    dispatch({ type: 'wlm/set-statusType', payload: Status.ERROR })
                } else {
                    var site = permittedSites[0]
                    dispatch({ type: 'wlm/set-selectedSite', payload: site.Id })
                    dispatch({ type: 'wlm/set-selectedSiteName', payload: site.SiteName })
                    dispatch({ type: 'wlm/set-selectedSiteTz', payload: site.TzCode })
                }
            },
            error: function () {
                dispatch({ type: 'wlm/set-permittedSites', payload: [] })
                dispatch({ type: 'wlm/set-selectedSite', payload: -1 })
                dispatch({ type: 'wlm/set-selectedSiteName', payload: '' })
                dispatch({ type: 'wlm/set-selectedSiteTz', payload: '' })
            },
        })
    }

    const loadPermissions = function () {
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/wlm/perms',
            cache: false,
            includeTokenHeader: true,
            success: function (response: {
                data: SetStateAction<{
                    CanDecline: boolean
                    CanSubmit: boolean
                    CanCancel: boolean
                }>
            }) {
                dispatch({ type: 'wlm/set-permissions', payload: response.data })
            },
        })
    }
    const toDate = (input: string | number | Date) => {
        return new Date(input)
    }

    // const loadTables = (status) =>{
    //     const waitConfig2Load = function () {
    //         setTimeout(function () {
    //             if (permittedSites.length < 1) {
    //                 waitConfig2Load();
    //             }
    //             else {
    //                 // loadItems(selectedSite, status, function (list) {
    //                 //     var lists2 = self.lists();
    //                 //     lists2[status] = list;
    //                 //     setists(lists2);

    //                 //     // => call load react component to load at corresponding IDs instead of using jquery node
    //                 //     // m.mount(node, new ListCompo(self, status));
    //                 // });
    //             }
    //         }, 50);
    //     };
    //     waitConfig2Load();
    // };

    const clearForm = (reset: boolean) => {
        // dispatch({
        //     type: 'wlm/clearForm',
        // })
        var selected = {
            actualRequesterId: currentUser,
            requestStatus: 1,
            effectiveRequesterId: currentUser,
            priority: PriorityCodes.routine,
            requestType: RequestType.adhoc,
            siteId: 0,
            SiteName: '',
            callbackNumber: '',
        }

        // setPickedRowId('')
        // setPickedElement(null)
        setDeleteOpen(false)
        setModalContents({})

        // Note that the 8th day designated ALL days
        dispatch({
            type: 'wlm/set-dayOfWeeks',
            payload: [true, true, true, true, true, false, false, false],
        })
        if (reset) {
            if (Object.keys(configs.modalities).length > 0) {
                dispatch({
                    type: 'wlm/set-modalityCounts',
                    payload: Object.keys(configs.modalities).map((_) => 0),
                })
            } else {
                dispatch({ type: 'wlm/set-modalityCounts', payload: modalityCounts?.map((_) => 0) })
            }
            if (Object.keys(configs.priorities).length > 0) {
                dispatch({
                    type: 'wlm/set-priorities',
                    payload: Object.values(configs.priorities).map((_, index) => {
                        if (index === 1) return true
                        return false
                    }),
                })
            } else {
                dispatch({
                    type: 'wlm/set-priorities',
                    payload: priorities?.map((_, index) => {
                        if (index === 1) return true
                        return false
                    }),
                })
            }
            if (Object.keys(configs.requestTypes).length > 0) {
                dispatch({
                    type: 'wlm/set-requestType',
                    payload: Object.values(configs.requestTypes).map((_, index) => {
                        if (index === 1) return true
                        return false
                    }),
                })
            } else {
                dispatch({
                    type: 'wlm/set-requestType',
                    payload: requestType?.map((_: any, index: number) => {
                        if (index === 1) return true
                        return false
                    }),
                })
            }
        }

        setNewComment('')
        dispatch({ type: 'wlm/set-comments', payload: [] })
        dispatch({ type: 'wlm/set-allowSitePick', payload: true })

        if (permittedSites && permittedSites.length > 0) {
            var site = permittedSites[0]
            dispatch({ type: 'wlm/set-selectedSite', payload: site.Id })
            dispatch({ type: 'wlm/set-selectedSiteName', payload: site.SiteName })
            dispatch({ type: 'wlm/set-selectedSiteTz', payload: site.TzCode })
        } else {
            dispatch({ type: 'wlm/set-selectedSite', payload: -1 })
            dispatch({ type: 'wlm/set-selectedSiteName', payload: '' })
            dispatch({ type: 'wlm/set-selectedSiteTz', payload: '' })
        }

        var sd = moment(new Date()).format('MM/DD/YYYY')
        dispatch({ type: 'wlm/set-startingDate', payload: sd })
        dispatch({ type: 'wlm/set-endingDate', payload: sd })
        dispatch({ type: 'wlm/set-startingTime', payload: '08:00:00' })
        dispatch({ type: 'wlm/set-endingTime', payload: '16:00:00' })
        dispatch({ type: 'wlm/set-selectedItem', payload: selected })

        // TODO NEXT! update priority [2] to be true and requestTYpe[1] to be true using redux here for default values
        // c.priority[2] = m.prop(true);
        // c.requestType[1] = m.prop(true);
    }

    const updateDayOfWeek = (index: number, checked: boolean) => {
        if (index === 7) {
            if (!checked) {
                dispatch({
                    type: 'wlm/set-dayOfWeeks',
                    payload: [true, true, true, true, true, false, false, false],
                })
            } else {
                dispatch({
                    type: 'wlm/set-dayOfWeeks',
                    payload: [true, true, true, true, true, true, true, true],
                })
            }
        } else {
            const tempDays = [...dayOfWeeks]
            tempDays[index] = checked

            const daysChecked = tempDays.slice(0, 7).filter((day) => day)?.length

            if (daysChecked === 7) {
                tempDays[7] = true
            } else {
                tempDays[7] = false
            }
            dispatch({ type: 'wlm/set-dayOfWeeks', payload: tempDays })
        }
    }

    const onRequestTypeChangd = (index: number) => {
        const tempRequest = requestType.map((_: any) => false)
        tempRequest[index - 1] = true
        dispatch({ type: 'wlm/set-requestType', payload: tempRequest })

        const tempItem = { ...selectedItem }
        tempItem.requestType = index
        dispatch({ type: 'wlm/set-selectedItem', payload: tempItem })
    }

    // const setPriorityForKey = (index: number, value: boolean) => {
    //     updateDispatchArray(value, index, priorities,'priorities')
    // }

    const setSelectedSiteId = (siteId: number) => {
        const tempItem = { ...selectedItem }
        tempItem.siteId = siteId
        dispatch({ type: 'wlm/set-selectedItem', payload: tempItem })
    }

    const setSelectedItemPriority = (priority: number | undefined) => {
        const tempItem = { ...selectedItem }
        tempItem.priority = priority
        dispatch({ type: 'wlm/set-selectedItem', payload: tempItem })
    }

    const updateModalityCounts = (index: number, value: number) => {
        updateDispatchArray(value, index, modalityCounts, 'modalityCounts')
    }

    const updateRequestTypes = (index: number, value: boolean) => {
        updateDispatchArray(value, index, requestType, 'requestType')
    }

    useEffect(() => {
        loadConfigs()
        loadPermissions()
        loadUser()
        loadPermittedSites()
        dispatch({ type: 'wlm/set-statusType', payload: Status.INFO })
        dispatch({ type: 'wlm/set-statusMessage', payload: '' })

        // TODO when the user laods an existing form need to update requesttype and priority accordingly
        // const currentPriority =
        //     selectedItem.priority == undefined || selectedItem.priority == 0
        //     ? PriorityCodes.routine
        //     : selectedItem.priority
        // const tempPriorities = priorities.map((_) => false)
        // tempPriorities[currentPriority] = true
        // setPriorities(tempPriorities)

        // const selectedType = ( selectedItem.requestType === undefined ||  selectedItem.requestType === 0) ? RequestType.adhoc : selectedItem.requestType;
        // updateRequestTypes(selectedType, true)

        // Object.keys(configs.requestTypes).forEach((key) => {
        //     if (Number(key) != selectedType) updateRequestTypes(Number(key), false)
        // })
    }, [])

    useEffect(() => {
        if (modalityCounts !== undefined && modalityCounts.length > 0) {
            setModalitySum(modalityCounts.reduce((val1, val2) => val1 + val2, 0))
        } else {
            setModalitySum(0)
        }
    }, [modalityCounts])

    // TODO pass thie setPriority funciton correctly so that the priority is set for the selected item specifically
    useEffect(() => {}, [])

    return (
        <>
            {
                // TODO add case for messageAsynch here instead of status message
                isMessageVisible && statusMessage ? (
                    statusType === Status.ERROR ? (
                        <div className="alert alert-danger status">{statusMessage}</div>
                    ) : (
                        <div className="alert alert-success status">{statusMessage}</div>
                    )
                ) : null // Render nothing if `isMessageVisible` is false
            }
            <div className="flex three">
                <div className="wlm-formdiv">
                    <table className="wlm-panel" style={{ width: '100%', height: '162.5px' }}>
                        <tr>
                            <td>Request ID:</td>
                            <td>{selectedItem.id ? selectedItem.id.toString() : ''}</td>
                        </tr>
                        <tr>
                            <td>Site: </td>
                            <td>
                                {permittedSites ? (
                                    <SiteCompo
                                        allowSitePick={allowSitePick}
                                        selectedSite={selectedSite}
                                        permittedSites={permittedSites}
                                        selectedItem={selectedItem}
                                        setSelectedSiteId={setSelectedSiteId}
                                    />
                                ) : (
                                    <>No sites available for this role</>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td>Status:</td>
                            <td>{RequestedStatusName['' + selectedItem.requestStatus]}</td>
                        </tr>
                        <tr>
                            <td>Created On:</td>
                            <td>
                                {selectedItem.ts_creationDateTime
                                    ? selectedItem.ts_creationDateTime.toLocaleDateString()
                                    : ''}
                            </td>
                        </tr>
                        <tr>
                            <td>Modified On:</td>
                            <td>
                                {selectedItem.ts_modificationDateTime
                                    ? selectedItem.ts_modificationDateTime.toLocaleDateString()
                                    : ''}
                            </td>
                        </tr>
                    </table>
                    <div className="wlm-panel">
                        Priority:
                        <PriorityCompo
                            selectedItem={selectedItem}
                            configs={configs}
                            priority={priorities}
                            setSelectedItemPriority={setSelectedItemPriority}
                        ></PriorityCompo>
                    </div>
                    <div className="wlm-panel">
                        <ModalityTableCompo
                            modalities={configs.modalities}
                            modalityCounts={modalityCounts}
                            modalitySum={modalitySum}
                            updateModalityCounts={updateModalityCounts}
                            setModalitySum={setModalitySum}
                        />
                    </div>
                    {permittedSites.length > 1 && permittedSites.filter(
                        (i: { TzCode: string }) => i.TzCode == undefined || i.TzCode == ''
                    )?.length > 0 ? (
                        <div className="field-validation-error">
                            Timezone Code missing for sites:{' '}
                            {permittedSites
                                .filter(
                                    (i: { TzCode: string }) =>
                                        i.TzCode == undefined || i.TzCode == ''
                                )
                                .map((site: { SiteName: string }) => site.SiteName)
                                .join(',')}
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="wlm-formdiv">
                    <div className="wlm-panel">
                        Type Of Request:
                        <RequestTypeCompo
                            onRequestTypeChangd={onRequestTypeChangd}
                            selectedItem={selectedItem}
                            setRequestType={updateRequestTypes}
                            configs={configs}
                            requestType={requestType}
                        />
                    </div>
                    <div className="wlm-panel requested-days">
                        Requested Days:{' '}
                        {<WeekCompo updateDayOfWeek={updateDayOfWeek} dayOfWeeks={dayOfWeeks} />}
                    </div>
                    <div className="wlm-panel site-time">
                        <tr>
                            <td colSpan={2}>
                                {selectedSiteName + ' (' + selectedSiteTz + ') Time'}
                            </td>
                        </tr>
                        <DateTimeCompo
                            dateValue={startingDate}
                            setDateValue={(date) => {
                                dispatch({ type: 'wlm/set-startingDate', payload: date })
                                if (date > endingDate) {
                                    dispatch({ type: 'wlm/set-endingDate', payload: date })
                                    if (endingTime < startingTime) {
                                        dispatch({
                                            type: 'wlm/set-endingTime',
                                            payload: startingTime,
                                        })
                                    }
                                }
                            }}
                            label="Starting Date"
                            time={startingTime}
                            setTime={(time) =>
                                dispatch({ type: 'wlm/set-startingTime', payload: time })
                            }
                        />
                        <DateTimeCompo
                            dateValue={endingDate}
                            setDateValue={(date) => {
                                dispatch({ type: 'wlm/set-endingDate', payload: date })
                                // Parse the dates as actual Date objects for comparison
                                const parsedStartingDate = new Date(startingDate)
                                const parsedEndingDate = new Date(typeof date === 'string' ? date : '');
                                // Ensure proper comparison between the two date objects
                                if (parsedEndingDate < parsedStartingDate) {
                                    dispatch({ type: 'wlm/set-startingDate', payload: date })
                                    if (endingTime < startingTime) {
                                        dispatch({
                                            type: 'wlm/set-startingTime',
                                            payload: endingTime,
                                        })
                                    }
                                }
                            }}
                            label="Ending Date"
                            time={endingTime}
                            setTime={(time) =>
                                dispatch({ type: 'wlm/set-endingTime', payload: time })
                            }
                        />
                    </div>
                </div>
                <div className="wlm-formdiv">
                    <div className="wlm-panel">
                        <div style={{ padding: '3px', width: '100%' }}>
                            Justification:
                            <textarea
                                value={newComment}
                                style={{
                                    padding: '3px',
                                    alignItems: 'text-top',
                                    height: '60px',
                                    width: '98%',
                                }}
                                placeholder="Please enter note before submitting or declining request"
                                onChange={(element) => setNewComment(element.currentTarget.value)}
                            ></textarea>
                        </div>
                    </div>
                    <div className="wlm-panel">
                        <div>
                            <CommentListCompo currentUser={currentUser} />
                        </div>
                    </div>
                    <table className="wlm-panel" style={{ width: '100%' }}>
                        <tr>
                            <td style={{ width: '25%' }}>
                                <input
                                    disabled={!permissions.CanSubmit}
                                    type="button"
                                    style={{ width: '100%' }}
                                    onClick={() => onNewForm()}
                                    value="Start New"
                                ></input>
                            </td>
                            <td style={{ width: '25%' }} colSpan={1}>
                                <input
                                    disabled={!permissions.CanCancel}
                                    type="button"
                                    style={{ width: '100%', color: 'orange' }}
                                    onClick={() => {
                                        if (permissions.CanCancel) setDeleteOpen(true)
                                    }}
                                    value="Delete"
                                ></input>
                                <Dialog
                                    isOpen={deleteOpen}
                                    title="Please Confirm"
                                    width={520}
                                    height={150}
                                    buttons={[
                                        {
                                            label: 'Cancel',
                                            onClick: () => setDeleteOpen(false),
                                            className:
                                                'app-button negative float-right ui-button ui-corner-all ui-widget',
                                        },
                                        {
                                            label: 'Delete',
                                            onClick: onDeleteRequest,
                                            className:
                                                'app-button float-right ui-button ui-corner-all ui-widget',
                                        },
                                    ]}
                                    onClose={cancelDelete}
                                >
                                    <div style={{ fontWeight: 'bold', padding: '10px' }}>
                                        Click Delete to permanently delete this request.
                                    </div>
                                </Dialog>
                            </td>
                        </tr>
                        <tr
                            className="viewOnly"
                            style={permissions.CanDecline ? {} : { display: 'None' }}
                        >
                            <td style={{ width: '25%' }}>
                                <input
                                    disabled={!permissions.CanDecline}
                                    type="button"
                                    style={{ width: '100%', color: 'green' }}
                                    onClick={() => onAccept()}
                                    value="Accept"
                                ></input>
                            </td>
                            <td style={{ width: '25%' }}>
                                <input
                                    disabled={!permissions.CanDecline}
                                    type="button"
                                    style={{ width: '100%', color: 'red' }}
                                    onClick={() => onDecline()}
                                    value="Decline"
                                ></input>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: '25%' }}>
                                <input
                                    disabled={!permissions.CanSubmit}
                                    type="button"
                                    style={{ width: '100%', color: 'blue' }}
                                    onClick={() => onSubmit()}
                                    value="Submit"
                                ></input>
                            </td>
                            <td></td>
                        </tr>
                    </table>
                </div>
            </div>

            {/* // TODO ->
                // m(statusDiv, typeof c.messageAsynch === "function" ? c.messageAsynch() : ctrl.statusMessage()), formDiv */}
        </>
    )
}

export default memo(WlmForm)
